import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import {
  Typography,
  Row,
  Col,
  Input,
  Select,
  Button,
  Space,
  Table,
  Form,
  Tooltip,
  Modal,
  Tag,
  Card,
  DatePicker,
  InputNumber,
  message,
  Radio,
  Menu,
  Dropdown,
  Checkbox,
} from "antd";
import dayjs from "dayjs";
import {
  CalculatorOutlined,
  CheckSquareOutlined,
  CloseSquareOutlined,
  DeleteFilled,
  EditOutlined,
  EllipsisOutlined,
  ExportOutlined,
  PlusCircleOutlined,
  PrinterOutlined,
  ReloadOutlined,
  BookOutlined,
  SearchOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { JournalCentralService } from "../Services/JournalCentralService";
import { TraitementService } from "../Services/TraitementService";
import "../Pages/CSS/Traitement.css";
import { printJournalSaisie } from "../Services/PrintJournalSaisieService";
import { AdherentsService } from "../Services/AdherentsService";

const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const SaisieJournal = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [messageApi, messageHolder] = message.useMessage();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [codesoc, setCodesoc] = useState("");
  const [listSociete, setListSociete] = useState([]);
  const [form] = Form.useForm();
  const [etat, setEtat] = useState("T");


  const journalCentralService = new JournalCentralService();
  const traitementsoinsService = new TraitementService();
  const adherentService = new AdherentsService();

  const getSelectedYear = () => {
    const currentYear = dayjs().year();
    return currentYear.toString();
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [journalData, setJournalData] = useState([]);
  const [selectJournal, setSelectJournal] = useState("ALL")
  const [compteGenData, setCompteGenData] = useState([]);
  const [getDetails, setGetDetails] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [compteTiersOptions, setCompteTiersOptions] = useState([]);
  const [isCompteTiersDisabled, setIsCompteTiersDisabled] = useState(true);
  const [isCompteTiersRequired, setIsCompteTiersRequired] = useState(false);

  ;
  const [selectedMonth, setSelectedMonth] = useState(/* getCurrentMonth() */null);
  const [paramData, setParamData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [years, setYears] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [totalDebit1, setTotalDebit1] = useState(0);
  const [totalCredit1, setTotalCredit1] = useState(0);
  const [soldeSelection, setSoldeSelection] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [debitAmount, setDebitAmount] = useState(0);
  const [creditAmount, setCreditAmount] = useState(0);
  const [totalDebitModal, setTotalDebitModal] = useState(0);
  const [totalCreditModal, setTotalCreditModal] = useState(0);

  const fetchData = async () => {
    setIsLoading(true);
    if (selectedYear && selectedMonth) {
      try {
        const data = await journalCentralService.getListSaisieJournal(
          selectedYear,
          selectedMonth
        );
        let filteredData = data;
        if (selectJournal !== "ALL") {
          filteredData = data.filter((d) => d.codej === selectJournal);
        }
        setTableData(filteredData);
        const yearsData = await journalCentralService.getComptaExercices();
        setYears([...yearsData].sort((a, b) => b - a));
        const listData = await journalCentralService.getList();
        setJournalData(listData);
        /* const getParam = await traitementsoinsService.getParamComptable();
        setParamData(getParam); */

        const totalDebitCalculated = filteredData.reduce(
          (acc, curr) => acc + (curr.debit || 0),
          0
        );
        const totalCreditCalculated = filteredData.reduce(
          (acc, curr) => acc + (curr.credit || 0),
          0
        );

        setTotalDebit(totalDebitCalculated);
        setTotalCredit(totalCreditCalculated);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const fetchDataInit = async () => {
    const dataListSociete = await adherentService.getAllAdherents();
    setListSociete(dataListSociete);
    const getParam = await traitementsoinsService.getParamComptable();
    setParamData(getParam);
    const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
    setSelectedYear(yearFromParamData)
    const monthFromParamData = dayjs(getParam.datedeb).format("MM");
    setSelectedMonth(monthFromParamData);
    fetchData()
  };

  const filterByEtat = (data, etatValue) => {
    if (etatValue === "T") return data;
    if (etatValue === "C") return data.filter(item => item.lettrage === "Oui");
    if (etatValue === "N") return data.filter(item => item.lettrage === "Non");
    return data;
  };

  useEffect(() => {

    fetchDataInit();
    return () => { };
  }, []);

  useEffect(() => {
    const totalDebitCalculated = filteredData.reduce(
      (acc, curr) => acc + (parseFloat(curr.debit) || 0),
      0
    );
    const totalCreditCalculated = filteredData.reduce(
      (acc, curr) => acc + (parseFloat(curr.credit) || 0),
      0
    );
    setTotalDebit(totalDebitCalculated);
    setTotalCredit(totalCreditCalculated);
  }, [filteredData]);

  const fetchListAll = async () => {
    try {
      const data = await journalCentralService.getPlanCompta();
      setCompteGenData(data);
    } catch (error) {
      console.log("Erreur lors de la récupération des adhérents:", error);
    }
  };

  const handleCompteGenChange = async (value) => {
    const selectedCompteGen = compteGenData.find(
      (compte) => compte.compte === value
    );

    if (!selectedCompteGen) return;

    if (selectedCompteGen.souscpte.startsWith("411") ||
      selectedCompteGen.souscpte.startsWith("463")) {
      const longSoc = await listSociete[0].codeadht.length;
      // setCodesoc(selectedCompteGen.compte.slice(-longSoc));
      form.setFieldsValue({
        codesoc: selectedCompteGen.compte.slice(-longSoc),
      });

    };

    if (
      selectedCompteGen.souscpte.startsWith("400") ||
      selectedCompteGen.souscpte.startsWith("421") ||
      selectedCompteGen.souscpte.startsWith("422") ||
      (selectedCompteGen.souscpte.startsWith("411") && selectedCompteGen.codepart)
    ) {
      setIsCompteTiersDisabled(false);

      setIsCompteTiersRequired(
        selectedCompteGen.souscpte.startsWith("400") ||
        selectedCompteGen.souscpte.startsWith("411")
      ); // Le champ compte tiers devient obligatoire uniquement pour "400" ou "411"

      try {
        const compteTiersData = await journalCentralService.getCompta(
          selectedCompteGen.compte,
          selectedCompteGen.souscpte,
          selectedCompteGen.codepart || ""
        );
        setCompteTiersOptions(compteTiersData);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des Comptes Tiers :",
          error
        );
        setIsCompteTiersDisabled(true);
      }
    } else {
      setIsCompteTiersDisabled(true);
      setIsCompteTiersRequired(false);
      setCompteTiersOptions([]);
    }
  };

  useEffect(() => {
    console.log(
      `Compte Tiers est ${isCompteTiersDisabled ? "désactivé" : "activé"}.`
    );
  }, [isCompteTiersDisabled]);

  useEffect(() => {
    console.log("Options de Compte Tiers :", compteTiersOptions);
  }, [compteTiersOptions]);



  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  const onchangePrestation = (value) => {
    setSelectJournal(value);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DatePiece: row.datepiece,
      NumPiece: row.numpiece,
      DateSaisie: row.datesaisie,
      dateTrait: row.datetrait,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matricule,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };

  const exportToExcel = (data, fileName = "export.xlsx") => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, fileName);
  };


  const handleDeleteline = async (numpiece) => {
    try {
      confirm({
        title: `Êtes-vous sûr de vouloir supprimer la piece N° ${numpiece}?`,
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await journalCentralService.deleteDetailsSaisie(numpiece);
            const updatedData = tableData.filter(
              (item) => item.numpiece !== numpiece
            );
            setTableData(updatedData);
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la confirmation de la suppression :",
        error
      );
    }
  };

  const handlePrint = async () => {
    if (selectedRowKeys.length === 0) {
      message.warning("Veuillez sélectionner au moins une ligne à imprimer.");
      return;
    }

    setIsLoading(true);
    try {
      const selectedData = tableData.filter(
        (item) => selectedRowKeys.includes(item.numligne)
      );

      const docData = selectedData.map((item) => item.numligne);

      await journalCentralService.printCompta(docData);
      printJournalSaisie();

      message.success("Les documents sont en cours d'impression.");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
      message.error("Une erreur est survenue lors de l'impression.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      let values = await form.validateFields();

      if (values.datepiece && dayjs.isDayjs(values.datepiece)) {
        values = {
          ...values,
          datepiece: values.datepiece.format("YYYY-MM-DD"),
        };
      }

      setGetDetails((prevDetails) =>
        prevDetails.map((item) => {
          const keyToCompare = isEditMode ? item.numligne : item.key;
          return keyToCompare === editingKey ? { ...item, ...values } : item;
        })
      );

      form.setFieldsValue({
        debit: 0,
        credit: 0,
        comptetiers: null,
        comptegen: null,
      });

      setDebitAmount(0);
      setCreditAmount(0);

      setEditingKey(null);
    } catch (errorInfo) {
      console.error("Validation Failed:", errorInfo);
    }
  };

  const handleAddToTable = async () => {
    try {
      const values = await form.validateFields();
      console.log("Received values of form: ", values);

      const formattedDatePiece = values.datepiece.format("YYYY-MM-DD");

      setGetDetails((prevDetails) => [
        ...prevDetails,
        {
          ...values,
          datepiece: formattedDatePiece,
          key: getDetails.length + 1,
        },
      ]);

      form.setFieldsValue({
        debit: 0,
        credit: 0,
        comptetiers: null,
        comptegen: null,
      });

      setDebitAmount(0);
      setCreditAmount(0);
    } catch (errorInfo) {
      console.error("Validation Failed:", errorInfo);
    }
  };

  const handleAddClick = async () => {
    form.resetFields();
    setIsModalVisible(true);
    setModalTitle("Saisir une écriture comptable");
    await fetchListAll();

    try {
      const getParam = await traitementsoinsService.getParamComptable();
      setParamData(getParam);

      form.setFieldsValue({ datetrait: dayjs(getParam.datedeb) });
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des paramètres comptables :",
        error
      );
    }
  };

  useEffect(() => {
    const newTotalDebit = getDetails.reduce(
      (sum, record) => sum + (record.debit || 0),
      0
    );
    const newTotalCredit = getDetails.reduce(
      (sum, record) => sum + (record.credit || 0),
      0
    );

    setTotalDebitModal(newTotalDebit);
    setTotalCreditModal(newTotalCredit);
  }, [getDetails]);

  const handleSave = async () => {
    try {
      await form.validateFields();

      const totalDebit = getDetails.reduce(
        (acc, detail) => acc + (detail.debit || 0),
        0
      );
      const totalCredit = getDetails.reduce(
        (acc, detail) => acc + (detail.credit || 0),
        0
      );
      const solde = totalDebit - totalCredit;

      const docData = getDetails.map((detail) => ({
        ...detail,
        codej: detail.codej,
        comptetiers: detail.comptetiers || null,
        datecompta: dayjs().toISOString(),
        datepiece: detail.datepiece
          ? dayjs(detail.datepiece).toISOString()
          : null,
        datetrait: detail.datetrait
          ? dayjs(detail.datetrait).toISOString()
          : null,
        debit: detail.debit,
        credit: detail.credit,
        matri: detail.matri || null,
        solde,
      }));

      const response = await journalCentralService.editCompta(docData);

      if (response) {
        message.success("Saisie mise à jour avec succès.");
        setIsModalVisible(false);
        setGetDetails([]);
        form.resetFields();
        setEditingKey(null);
        fetchData();
        setDebitAmount(0);
        setCreditAmount(0);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour des données :", error);
      message.error(
        "Une erreur est survenue lors de la mise à jour de la saisie."
      );
    }
  };

  const handleOk = async () => {
    try {
      // Validation du tableau uniquement
      if (getDetails.length === 0) {
        Modal.error({
          title: "Erreur",
          content: "Veuillez ajouter au moins une ligne au tableau",
        });
        return;
      }

      const totalDebit = getDetails.reduce(
        (acc, detail) => acc + (detail.debit || 0),
        0
      );
      const totalCredit = getDetails.reduce(
        (acc, detail) => acc + (detail.credit || 0),
        0
      );
      const solde = totalDebit - totalCredit;
      if (solde !== 0) {
        Modal.error({
          title: "Avertissement",
          content: "Le journal n'est pas équilibré",
        });
        return;
      }
      const payloads = getDetails.map((detail) => ({
        ...detail,
        codej: detail.codej,
        ref_piece: detail.ref_piece,
        comptetiers: detail.comptetiers || null,
        datecompta: dayjs().toISOString(),

        datepiece: detail.datepiece
          ? dayjs(detail.datepiece).toISOString()
          : null,
        datetrait: detail.datetrait
          ? dayjs(detail.datetrait).toISOString()
          : null,
        debit: detail.debit,
        credit: detail.credit,
        matri: detail.matri || null,
        solde,
      }));

      const response = await journalCentralService.addJournalCentral(payloads);
      message.success("Saisie ajoutée avec succès.");
      setIsModalVisible(false);
      await fetchData();
      handleCancel();
      resetTableData();
      setDebitAmount(0);
      setCreditAmount(0);
      setEditingKey(null);
    } catch (error) {
      console.error("Erreur lors de l'envoi des données :", error);
    }
  };

  const resetTableData = () => {
    setGetDetails([]);
  };

  const onEdit = async (record) => {
    setIsEditMode(true);
    try {
      setIsLoading(true);
      await fetchListAll();
      const details = await journalCentralService.getdetailsSaisie(
        record.numpiece
      );
      if (details) {
        setGetDetails(details);

        form.setFieldsValue({
          datepiece: record.datepiece ? dayjs(record.datepiece) : null,
          datetrait: record.datetrait ? dayjs(record.datetrait) : null,
          codej: record.codej,
          comptetiers: record.comptetiers,
          libelle: record.libelle,
          numpiece: record.numpiece,
          numcheque: record.numcheque,
        });

        setIsModalVisible(true);
        setModalTitle("Modifier l'entrée");
        setEditingKey(record.numligne);
        setEditingKey(null);
      } else {
        console.error("Aucun détail trouvé pour ce numpiece :", record.numpiece);
        message.error("Les détails de cette entrée n'ont pas pu être chargés.");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des détails :", error);
      message.error(
        "Une erreur est survenue lors de la récupération des détails."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const formatNumber = (number) => {
    const num = Number(number);
    if (isNaN(num)) {
      return "0";
    }

    return new Intl.NumberFormat("fr-FR").format(num);
  };

  const disableFutureDates = (current) => {
    return current && current > dayjs().endOf("day");
  };


  useEffect(() => {
    const selectedRows = filteredData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );
    const montotalDebit1 = selectedRows.reduce(
      (sum, record) => sum + parseFloat(record.debit || 0),
      0
    );
    const montotalCredit1 = selectedRows.reduce(
      (sum, record) => sum + parseFloat(record.credit || 0),
      0
    );

    setTotalDebit1(montotalDebit1);
    setTotalCredit1(montotalCredit1);

    const newSoldeSelection = montotalDebit1 - montotalCredit1;
    setSoldeSelection(newSoldeSelection);
  }, [selectedRowKeys, filteredData]);


  const monthOptions = [
    { value: "13", label: "Tous les mois" },
    { value: "01", label: "Janvier" },
    { value: "02", label: "Février" },
    { value: "03", label: "Mars" },
    { value: "04", label: "Avril" },
    { value: "05", label: "Mai" },
    { value: "06", label: "Juin" },
    { value: "07", label: "Juillet" },
    { value: "08", label: "Août" },
    { value: "09", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  const columns = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      filterSearch: true,
      // sorter: (a, b) => a.codej - b.codej,
      sorter: (a, b) => {
        const valueA = a.codej || "";
        const valueB = b.codej || "";
        return valueA.localeCompare(valueB);
      },
      align: "center",
    },
    {
      title: "Date pièce",
      dataIndex: "datepiece",
      key: "datepiece",
      // sorter: (a, b) => a.datepiece - b.datepiece,
      sorter: (a, b) => {
        const valueA = new Date(a.datepiece).getTime();
        const valueB = new Date(b.datepiece).getTime();
        return valueA - valueB;
      },
      align: "center",
      render: (text) => (text ? dayjs(text).format("DD/MM/YYYY") : "—"),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      sorter: (a, b) => a.numpiece - b.numpiece,
      align: "center",

    },
    {
      title: "Date saisie",
      dataIndex: "datesaisie",
      key: "datesaisie",
      // sorter: (a, b) => a.datesaisie - b.datesaisie,
      sorter: (a, b) => {
        const valueA = new Date(a.datesaisie).getTime();
        const valueB = new Date(b.datesaisie).getTime();
        return valueA - valueB;
      },
      align: "center",
      render: (text) => (text ? dayjs(text).format("DD/MM/YYYY") : "—"),
    },
    {
      title: "Mois trait",
      dataIndex: "datetrait",
      key: "datetrait",
      sorter: (a, b) => {
        const valueA = new Date(a.datetrait).getTime();
        const valueB = new Date(b.datetrait).getTime();
        return valueA - valueB;
      },
      render: (text) => (
        <div style={{ backgroundColor: "#ADD8E6", textAlign: "center" }}>
          {text ? <b>{dayjs(text).format("MMM-YYYY")}</b> : "—"}
        </div>
      ),
      align: "center",
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      filterSearch: true,
      sorter: (a, b) => a.comptegen - b.comptegen,
      align: "center",
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      sorter: (a, b) => a.comptetiers - b.comptetiers,
      filterSearch: true,
      align: "center",
    },
    {
      title: "Code soc.",
      dataIndex: "codesoc",
      key: "codesoc",
      sorter: (a, b) => a.codesoc - b.codesoc,
      filterSearch: true,
      align: "center",
    },
    {
      title: "Debit",
      dataIndex: "debit",
      key: "debit",
      sorter: (a, b) => a.debit - b.debit,
      filterSearch: true,
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
          </strong>
        </div>
      ),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 200 }}>
          {/* Recherche personnalisée */}
          <Input
            placeholder="Rechercher montant"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys([e.target.value])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8 }}
          />
          {/* Plages de filtres prédéfinies */}
          <div style={{ marginBottom: 8 }}>
            <Radio.Group
              onChange={(e) => {
                setSelectedKeys([e.target.value]);
                confirm();
              }}
              value={selectedKeys[0]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="100-100000">100 - 100,000</Radio>
              <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
              <Radio value="1000000-">Plus de 1,000,000</Radio>
            </Radio.Group>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (value.includes("-")) {
          const [min, max] = value.split("-").map(Number);
          if (!max) return record.debit >= min; // Plus de 1,000,000
          return record.debit >= min && record.debit <= max; // Plage spécifique
        }
        const parsedValue = parseFloat(value);
        return record.debit === parsedValue; // Recherche directe
      },
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      sorter: (a, b) => a.credit - b.credit,
      filterSearch: true,
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
          </strong>
        </div>
      ),
    },
    {
      title: "Etat",
      dataIndex: "lettrage",
      key: "lettrage",
      sorter: (a, b) => a.lettrage - b.lettrage,
      filterSearch: true,
      ellipsis: true,
      align: "center",
      render: (text) => {
        let tagColor, tagText;

        switch (text) {
          case "Non":
            tagColor = "#f2b305";
            tagText = "N";
            break;
          case "Oui":
            tagColor = "#46de04";
            tagText = "C";
            break;
          default:
            tagColor = "#000000";
            tagText = text;
        }

        return <Tag color={tagColor}>{tagText}</Tag>;
      },
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      // sorter: (a, b) => a.libelle - b.libelle,
      sorter: (a, b) => {
        const valueA = a.libelle || "";
        const valueB = b.libelle || "";
        return valueA.localeCompare(valueB);
      },
      filterSearch: true,
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      fixed: "right",
      render: (text, record) => {
        if (record.lettrage === "Non") {
          return (
            <span>
              <Tooltip title="Modifier">
                <EditOutlined
                  style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
                  onClick={() => onEdit(record)}
                />
              </Tooltip>
              <Tooltip title="Supprimer">
                <DeleteFilled
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => handleDeleteline(record.numpiece)}
                />
              </Tooltip>
            </span>
          );
        } else {
          return null;
        }
      },
    },
  ];

  useEffect(() => {
    fetchData();
    // setFilteredData(tableData);
  }, [selectedYear, selectedMonth, selectJournal]);

  useEffect(() => {
    setFilteredData(filterByEtat(tableData, etat));
  }, [tableData, etat]);

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered);
    setSearchText(value);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsCompteTiersRequired(false);
    setIsCompteTiersDisabled(true)
    setEditingKey(null);
    resetTableData();
    setDebitAmount(0);
    setCreditAmount(0);
    form.resetFields();
    setIsEditMode(false);
  };

  const onSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };



  const allRowKeys = filteredData.map((record) => record.numligne);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = filteredData.map((item) => item.numligne);
          setSelectedRowKeys(allKeys);
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRowKeys([]);
        },
      },
    ],
    getCheckboxProps: (record) => ({
      name: record.numligne,
      // Désactiver la case à cocher si l'état de la ligne est "Oui" (comptabilisé)
      // disabled: record.lettrage === "Oui",
    }),
  };

  const handleDebitChange = (value) => {
    setDebitAmount(value || 0);
    setCreditAmount(0);
    form.setFieldsValue({ credit: 0 });
  };

  const handleCreditChange = (value) => {
    setCreditAmount(value || 0);
    setDebitAmount(0);
    form.setFieldsValue({ debit: 0 });
  };
  const selectedData = tableData.filter(
    (item) => selectedRowKeys.includes(item.numligne)
  );
  const solde = selectedData.reduce(
    (acc, item) => acc + (item.debit || 0) - (item.credit || 0),
    0
  );

  const isAllSelectedLettrageOui = selectedRowKeys.every(
    (key) => {
      const row = filteredData.find((item) => item.numligne === key);
      return row && row.lettrage === "Oui";
    }
  );

  // Mettre à jour la logique pour désactiver le bouton
  const isButtonDisabled = selectedRowKeys.length === 0 || isAllSelectedLettrageOui || solde !== 0;

  const isButtonImpDisabled = selectedRowKeys.length === 0;



  /*   const handleComptabiliser = async () => {
      if (selectedRowKeys.length === 0) {
        message.error(
          "Veuillez sélectionner des lignes dont le solde est égale à 0 pour pouvoir comptabiliser."
        );
        return;
      } 
     
      if (solde !== 0) {
        message.warning(
          "La somme des débits et crédits des lignes sélectionnées doit être égale à zéro."
        );
        return;
      }
  
      try {
        const result = await journalCentralService.comptabJournalCentral(
          selectedData
        );
        console.log(result);
        message.success("La comptabilisation a été effectuée avec succès.");
        await fetchData();
        setSelectedRowKeys([]);
      } catch (error) {
        message.error("Une erreur est survenue lors de la comptabilisation.");
        console.error(error);
      }
    }; */


  const handleComptabiliser = async () => {
    if (selectedRowKeys.length === 0) {
      Modal.error({
        title: "Aucune sélection",
        content: "Veuillez sélectionner des lignes dont le solde est égal à 0 pour pouvoir comptabiliser.",
        okText: "Compris",
      });
      return;
    }

    if (solde !== 0) {
      Modal.warning({
        title: "Solde non équilibré",
        content: "La somme des débits et crédits des lignes sélectionnées doit être égale à zéro.",
        okText: "OK",
      });
      return;
    }

    // Vérification des lignes comptabilisées
    const lignesComptabilisees = selectedRowKeys.filter((key) => {
      const row = filteredData.find((item) => item.numligne === key);
      return row && row.lettrage === "Oui";
    });

    if (lignesComptabilisees.length > 0) {
      Modal.error({
        title: "Lignes déjà comptabilisées",
        content: "Veuillez sélectionner uniquement des lignes non comptabilisées.",
        okText: "Compris",
      });
      return;
    }

    modal.confirm({
      title: "Confirmation de comptabilisation",
      content: "Êtes-vous sûr de vouloir comptabiliser les lignes sélectionnées ?",
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          const result = await journalCentralService.comptabJournalCentral(
            selectedData
          );
          console.log(result);
          message.success("La comptabilisation a été effectuée avec succès.");
          await fetchData();
          setSelectedRowKeys([]);
        } catch (error) {
          message.error("Une erreur est survenue lors de la comptabilisation.");
          console.error(error);
        }
      },
    });
  };


  const handleDelete = (key) => {
    const newData = getDetails.filter((item) => item.key !== key);
    setGetDetails(newData);
  };

  const handleSelectChange = (value) => {
    setEtat(value);
    setFilteredData(filterByEtat(tableData, value));
  };

  return (
    <div style={{ padding: 12 }}>
      {contextHolder}
      {messageHolder}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <BookOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Saisie Journal
        </span>
      </div>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <p>
            Solde débit:
            <span>
              <strong style={{ color: "#c40208" }}>
                {" "}
                {formatNumber(totalDebit)}
              </strong>
            </span>
          </p>
          <p>
            Solde crédit:
            <span>
              <strong style={{ color: "#c40208" }}>
                {" "}
                {formatNumber(totalCredit)}
              </strong>
            </span>
          </p>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={16}
          lg={16}
          xl={16}
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          <Space wrap>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Exercice</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 100,
                  "--select-accent": "#1890ff",
                  "--select-accent-bg": "#e6f4ff",
                  "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {years.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Mois</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 140,
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                onChange={setSelectedMonth}
                value={selectedMonth}
              >
                {monthOptions.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Journal</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 300,
                  "--select-accent": "#52c41a",
                  "--select-accent-bg": "#f6ffed",
                  "--select-accent-shadow": "rgba(82, 196, 26, 0.25)",
                }}
                defaultValue={selectJournal}
                onChange={onchangePrestation}
                showSearch
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value="ALL">Tous</Select.Option>
                {journalData.map((journal) => (
                  <Option key={journal.codej} value={journal.codej}>
                    {` ${journal.codej} - ${journal.libelle}`}
                  </Option>
                ))}
              </Select>
            </Space>
            <Button
              icon={<PrinterOutlined />}
              className="buttonImprim"
              disabled={isButtonImpDisabled}
              onClick={handlePrint}
              style={{ marginTop: 25 }}
            >
              Imprimer
            </Button>
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="refresh"
                    icon={<ReloadOutlined style={{ color: "#1890ff" }} />}
                    onClick={() => fetchData()}
                  >
                    Actualiser
                  </Menu.Item>
                  <Menu.Item
                    key="export"
                    icon={<ExportOutlined style={{ color: "#1890ff" }} />}
                    onClick={() =>
                      exportToExcel(
                        prepareDataForExport(filteredData),
                        "JournalExport.xlsx"
                      )
                    }
                  >
                    Exporter
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
            >
              <Button
                className="buttonRefresh"
                style={{
                  marginTop: 25,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  fontWeight: 500,
                }}
              >
                Actions <DownOutlined />
              </Button>
            </Dropdown>
            <Button
              icon={<CalculatorOutlined />}
              className="buttonCompta"
              disabled={isButtonDisabled}
              onClick={handleComptabiliser}
              style={{ marginTop: 25 }}
            >
              Comptabiliser
            </Button>
            <Button
              icon={<PlusCircleOutlined />}
              type="primary"
              style={{ marginTop: 25 }}
              onClick={handleAddClick}
            >
              Saisir
            </Button>
            <Select
              value={etat}
              style={{
                width: 250,
                marginTop: 25,
                borderRadius: 8,
              }}
              onChange={handleSelectChange}
              placeholder="Filtrer par état"
              suffixIcon={<EllipsisOutlined style={{ color: '#1890ff' }} />}
            >
              <Option value="T">
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 16 }}>📋</span>
                  <span>Toutes les écritures</span>
                </span>
              </Option>
              <Option value="C">
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 16, color: '#52c41a' }}>✓</span>
                  <span>Comptabilisées</span>
                </span>
              </Option>
              <Option value="N">
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 16, color: '#faad14' }}>⏳</span>
                  <span>Non Comptabilisées</span>
                </span>
              </Option>
            </Select>
            {/* <Dropdown
              menu={{
                items: [
                  {
                    key: "select-all",
                    label: (
                      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <CheckSquareOutlined style={{ color: "#52c41a", fontSize: 16 }} />
                        <span>Sélectionner toutes les lignes</span>
                      </span>
                    ),
                    onClick: () => {
                      const allKeys = filteredData.map((item) => item.numligne);
                      setSelectedRowKeys(allKeys);
                    },
                  },
                  {
                    key: "clear-selection",
                    label: (
                      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <CloseSquareOutlined style={{ color: "#ff4d4f", fontSize: 16 }} />
                        <span>Désélectionner toutes les lignes</span>
                      </span>
                    ),
                    onClick: () => {
                      setSelectedRowKeys([]);
                    },
                  },
                ],
              }}
              placement="bottomLeft"
            >
              <Button
                style={{
                  marginTop: 25,
                  borderRadius: 8,
                  background: "linear-gradient(135deg, #00b4db 0%, #0083b0 100%)",
                  border: "none",
                  color: "white",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  boxShadow: "0 2px 8px rgba(0, 180, 219, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 180, 219, 0.5)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 180, 219, 0.3)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <CheckSquareOutlined style={{ fontSize: 16 }} />
                Sélections
              </Button>
            </Dropdown> */}

          </Space>
        </Col>
      </Row>
      <Card style={{ padding: 0 }}>
        <Table
          dataSource={filteredData}
          scroll={{ x: true }}
          className="custom-header2-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          pagination={{
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
            showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
            pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
            onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
          }}
          showSorterTooltip={false}
          rowSelection={rowSelection}
          columns={columns}
          rowKey="numligne"
          title={() => (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Space>
                <strong>Lignes selectionnées ({selectedRowKeys.length}) : </strong>
                <strong>Total Débit: {formatNumber(totalDebit1)}</strong> -
                <strong>Total Crédit: {formatNumber(totalCredit1)}</strong>
              </Space>
              <Input
                className="search-input-highlight"
                placeholder="Rechercher..."
                allowClear
                prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                style={{ width: 250 }}
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <Space>
                <strong>Solde de la sélection:</strong>
                <b style={{ color: "#4DBD74" }}>
                  {soldeSelection.toLocaleString()}
                </b>
              </Space>
            </div>
          )}
        />
      </Card>
      <Modal
        title={isEditMode ? "Modifier une écriture" : "Ajouter une écriture comptable"}
        open={isModalVisible}
        onOk={isEditMode ? handleSave : handleOk}
        maskClosable={false}
        width={1100}
        style={{ top: 20 }}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical" size="small" name="form_in_modal">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="datetrait"
                label="Mois Traitement"
                rules={[{ required: true, message: "Champs requis" }]}

              >
                <DatePicker
                  format="MMM.YYYY"
                  picker="month"
                  disabledDate={disableFutureDates}
                  style={{ width: "55%" }}
                />
              </Form.Item>
              <Form.Item
                name="codej"
                label="Code.Journal"
                rules={[{ required: true, message: "Champs requis" }]}
              >
                <Select
                  showSearch
                  placeholder="Sélectionnez un journal"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {journalData.map((journal) => (
                    <Option
                      key={journal.codej}
                      value={journal.codej}
                    >{`${journal.codej} - ${journal.libelle}`}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="comptegen"
                label="Compte général"
                rules={[{ required: true, message: "Champs requis" }]}
              >
                <Select
                  showSearch
                  placeholder="Sélectionnez un compte"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={handleCompteGenChange}
                >
                  {compteGenData
                    .filter((comptegen) => comptegen.compte.length >= 6) // Filtrer les comptes avec 6 chiffres ou plus
                    .map((comptegen) => (
                      <Option key={comptegen.compte} value={comptegen.compte}>
                        {`${comptegen.compte} - ${comptegen.intitule}`}
                      </Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="libelle"
                label="Libellé"
                rules={[{ required: true, message: "Champs requis" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="codesoc" hidden>
                <Input />
              </Form.Item>

              {/* <Form.Item
                name="codesoc"
                label="Societé"
              // rules={[{ required: true, message: "Champs requis" }]}
              >
                <Select
                  showSearch
                  placeholder="Sélectionnez une société"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {listSociete.map((soc) => (
                    <Option
                      key={soc.codeadht}
                      value={soc.codeadht}
                    >{`${soc.codeadht} - ${soc.intitule}`}</Option>
                  ))}
                </Select>
              </Form.Item> */}
              <Row gutter={16}>

                <Col span={8}>
                  <Form.Item
                    name="datepiece"
                    label="Date Pièce "
                    initialValue={dayjs()}
                    rules={[{ required: true, message: "Champs requis" }]}
                  >
                    <DatePicker
                      disabledDate={disableFutureDates}
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="numcheque" label="N° chèque">
                    <Input />
                  </Form.Item>

                </Col>
                <Col span={8}>
                  <Form.Item name="ref_piece" label="Référence">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                name="comptetiers"
                label="Compte Tiers"
                rules={[
                  {
                    required: isCompteTiersRequired,
                    message: "Compte Tiers requis ",
                  },
                ]}
              >
                <Select disabled={isCompteTiersDisabled} showSearch>
                  {compteTiersOptions.map((option) => (
                    <Option key={option.comptetiers} value={option.comptetiers}>
                      {`${option.comptetiers} - ${option.participant || option.fournisseur
                        }`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="debit"
                    label={`Mtt. Débit (${formatNumber(debitAmount)})`}
                    rules={[{ required: true, message: "Champs requis" }]}
                  >
                    <InputNumber
                      value={debitAmount}
                      onChange={handleDebitChange}
                      // min={0}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item
                    name="credit"
                    label={`Mtt. Crédit (${formatNumber(creditAmount)})`}
                    rules={[{ required: true, message: "Champs requis" }]}
                  >
                    <InputNumber
                      value={creditAmount}
                      onChange={handleCreditChange}
                      //  min={0}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Button
                    className="Buttonvalid"
                    style={{ marginTop: 30 }}
                    onClick={() => {
                      if (editingKey !== null) {
                        handleUpdate();
                      } else {
                        handleAddToTable();
                      }
                    }}
                  >
                    {editingKey !== null ? "Modifier Saisie" : "Valider Saisie"}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Table
            onRow={(record) => {
              return {
                onClick: () => {
                  form.setFieldsValue({
                    comptegen: record.comptegen,
                    comptetiers: record.comptetiers,
                    libelle: record.libelle,
                    numcheque: record.numcheque,
                    ref_piece: record.ref_piece,
                    debit: record.debit || 0,
                    credit: record.credit || 0,
                    datepiece: record.datepiece
                      ? dayjs(record.datepiece, "YYYY-MM-DD")
                      : null,
                  });
                  setDebitAmount(record.debit || 0);
                  setCreditAmount(record.credit || 0);
                  setEditingKey(isEditMode ? record.numligne : record.key);
                },
              };
            }}
            scroll={{ x: true }}
            style={{
              cursor: "pointer",
              whiteSpace: "nowrap",
              width: "100%",
            }}
            className="custom-header-table"
            footer={() => (
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Space>
                  <strong>Débit: {formatNumber(totalDebitModal, { showMinus: true })}</strong>
                  <strong>Crédit: {formatNumber(totalCreditModal, { showMinus: true })}</strong>
                  <strong style={{ color: "#008000" }}>Solde: {formatNumber(totalDebitModal - totalCreditModal, { showMinus: true })}</strong>
                </Space>
              </div>
            )}
            bordered
            dataSource={getDetails}
            columns={[
              { title: "Réf.Piece", dataIndex: "ref_piece", key: "ref_piece" },
              {
                title: "Date Piece",
                dataIndex: "datepiece",
                key: "datepiece",
                align: "center",
              },
              {
                title: "Cpte. Gen.",
                dataIndex: "comptegen",
                key: "comptegen",
                align: "center",
              },
              {
                title: "Compte Tiers",
                dataIndex: "comptetiers",
                key: "comptetiers",
                align: "right",
              },
              {
                title: "N° Chéque",
                dataIndex: "numcheque",
                key: "numcheque",
                align: "right",
              },
              {
                title: "Libellé",
                dataIndex: "libelle",
                key: "libelle",
                align: "right",
              },
              {
                title: "Débit",
                dataIndex: "debit",
                key: "debit",
                align: "right",
                render: (text) => (
                  <div style={{ paddingRight: 10 }}>
                    {text && parseFloat(text) !== 0
                      ? formatNumber(parseFloat(text))
                      : ""}
                  </div>
                ),
              },
              {
                title: "Crédit",
                dataIndex: "credit",
                key: "credit",
                align: "right",
                render: (text) => (
                  <div style={{ paddingRight: 10 }}>
                    {text && parseFloat(text) !== 0
                      ? formatNumber(parseFloat(text))
                      : ""}
                  </div>
                ),
              },
              {
                title: (
                  <div
                    style={{
                      backgroundColor: "#010f1c",
                      color: "white",
                      padding: "1px",
                    }}
                  ></div>
                ),
                dataIndex: "actions",
                key: "actions",
                align: "center",
                fixed: "right",
                render: (text, record) => (
                  <span>
                    <Tooltip title="Supprimer">
                      <DeleteFilled
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleDelete(record.key);
                        }}
                      />
                    </Tooltip>
                  </span>
                ),
              },
            ]}
          />
        </Form>
      </Modal>
    </div>
  );
};

export default SaisieJournal;
